import { render, staticRenderFns } from "./MotorClaimUpdateStatus.vue?vue&type=template&id=77ba4d52&"
import script from "./MotorClaimUpdateStatus.vue?vue&type=script&lang=js&"
export * from "./MotorClaimUpdateStatus.vue?vue&type=script&lang=js&"
import style0 from "./MotorClaimUpdateStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MotorClaimUpdateStatus.vue"
export default component.exports